<app-vervendo-header *ngIf="showHeader"></app-vervendo-header>
<router-outlet (activate)="onActivate($event)"></router-outlet>
<app-vervendo-footer *ngIf="!isMobile()" id="vervendo-footer"></app-vervendo-footer>
